const routes = [
    {
        path: "/accounts/receivables/dashboard",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "accountsreceivable_summary"
        }
    }
];

export default routes;
